import { render, staticRenderFns } from "./FrmItemDetail.vue?vue&type=template&id=5daa59fc&scoped=true"
import script from "./FrmItemDetail.vue?vue&type=script&lang=js"
export * from "./FrmItemDetail.vue?vue&type=script&lang=js"
import style0 from "./FrmItemDetail.vue?vue&type=style&index=0&id=5daa59fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daa59fc",
  null
  
)

export default component.exports